import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import './AppSwitcher.css';

const APPS = [
  { key: 'sat', to: '/', label: 'SAT Prep' },
  { key: 'college-algebra', to: '/college-algebra', label: 'College Algebra' },
];

// Small app-picker menu shown in both apps' headers, next to the brand name,
// so switching between SAT Prep and College Algebra doesn't require typing a
// URL -- they're two separate page trees (see App.js) sharing one account.
export default function AppSwitcher({ current }) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  return (
    <div className="app-switcher" ref={containerRef}>
      <button
        type="button"
        className="app-switcher-toggle"
        aria-label="Switch app"
        aria-haspopup="true"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        &#9776;
      </button>
      {open && (
        <div className="app-switcher-menu" role="menu">
          {APPS.map((app) => (
            <Link
              key={app.key}
              to={app.to}
              role="menuitem"
              className={`app-switcher-item ${app.key === current ? 'app-switcher-item--active' : ''}`}
              onClick={() => setOpen(false)}
            >
              {app.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
